import Odoo from './Odoo';

class TransportAPIClass{
    getMonths(pid){
      var params = [parseInt(pid)]

      return new Promise((resolve, reject) => {
        Odoo.call('res.partner', 'get_transport_months', params).then(months => {
          resolve(months);
        }).catch(err=>{
          reject(err)
        })
      })
    }

    getTransports(pid, year, month){
      var params = [parseInt(pid), year, month]
      return new Promise((resolve, reject) => {
        Odoo.call('res.partner', 'get_month_transports', params).then(month => {
          resolve(month);
        }).catch(err=>{
          reject(err)
        })
      });
    }
}

const TransportAPI = new TransportAPIClass()

export default TransportAPI



// WEBPACK FOOTER //
// ./src/utils/TransportAPI.js